import React, { useEffect, useState } from 'react'
import { useQuery } from "@tanstack/react-query"
import { getScheduleMainGridUnits } from "data/Querys"
import { ALL_URL, isValidDate, useScrollToTop } from "helpers/utils"
import Loader from 'components/general/Loader';
import NotAvailable from 'components/common/NotAvailable';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import ScheduleDisciplineAndDate from './schedule/ScheduleDisciplineAndDate';
import ScheduleDiscipline from './schedule/ScheduleDiscipline';
import ScheduleDate from './schedule/ScheduleDate';
const SchedulePageStatuses = { ONLY_DAY: 1, ONLY_DISCIPLINE: 2, DAY_AND_DISCIPLINE: 3, NO_DAY_NO_DISCIPLINE: 4 };

export default function Schedule() {
    let params = useUrlFriendlyToParameters()//useParams();
    const { mirs_discipline, mirs_date, mirs_event } = params;
    const [pageStatus, setPageStatus] = useState();
    useScrollToTop();

    useEffect(() => {
        if (mirs_discipline === ALL_URL.ALL_DISC) {
            if (isValidDate(mirs_date)) {
                setPageStatus(SchedulePageStatuses.ONLY_DAY)
            } else {
                setPageStatus(SchedulePageStatuses.NO_DAY_NO_DISCIPLINE)
            }
        } else if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
            if (isValidDate(mirs_date)) {
                setPageStatus(SchedulePageStatuses.DAY_AND_DISCIPLINE)
            } else {
                setPageStatus(SchedulePageStatuses.ONLY_DISCIPLINE)
            }
        }
    }, [mirs_date, mirs_discipline, mirs_event])

    //Copy object in order to change 
    let paramsURL = { ...params }

    if (!isValidDate(paramsURL['mirs_date'])) {
        paramsURL['mirs_date'] = undefined
    }

    const { data: scheduleGridData, isError: isErrorScheduleGrid, isLoading: isLoadingScheduleGrid } = useQuery(
        {
            queryKey: ['scheduleMainGrid', paramsURL['mirs_competition'], paramsURL['mirs_language']],
            queryFn: getScheduleMainGridUnits,
            refetchInterval: 30000,
            enabled: true,
        });
    if (isErrorScheduleGrid) { return <NotAvailable />; }
    if (isLoadingScheduleGrid) { return <Loader /> }
    let comp;
    if (pageStatus === SchedulePageStatuses.NO_DAY_NO_DISCIPLINE) {
        //N/A
    }
    else if (pageStatus === SchedulePageStatuses.ONLY_DAY) {
        comp = <ScheduleDate scheduleGridData={scheduleGridData} />
    }
    else if (pageStatus === SchedulePageStatuses.ONLY_DISCIPLINE) {
        comp = <ScheduleDiscipline />

    }
    else if (pageStatus === SchedulePageStatuses.DAY_AND_DISCIPLINE) {
        comp = <ScheduleDisciplineAndDate />
    }
    return comp
}





